import { BoxPlotTwoTone } from "@ant-design/icons";
import {Spin, Typography} from "antd";
import React, {useEffect} from "react";
import Plot from 'react-plotly.js';
import { connect } from 'react-redux';

import ApiService from "../../features/apiService";
import {setHiddenCompounds} from "../../features/peptideBoxPlot/peptideBoxPlotActions";
import AwesomeDebouncePromise from "awesome-debounce-promise";

const { Text, Title } = Typography;

const debouncedBoxPlotRequest = AwesomeDebouncePromise((token, experimentId, accessionId, normalized) => ApiService.getPeptideBoxPlotData(token, experimentId, accessionId, normalized), 500);

function PeptideBoxPlot({
    experimentId,
    accessionId,
    normalized,
    token,
    setHiddenCompounds,
}) {
    const [loading, setLoading] = React.useState(false);
    const [dataPoints, setDataPoints] = React.useState();
    const [plotTitle, setPlotTitle] = React.useState();

    const updateShownCompounds = () => {
        const hiddenCompounds = dataPoints
            .filter(trace => trace.visible === 'legendonly')
            .map(trace => trace.name);

        setHiddenCompounds(hiddenCompounds);
    }

    useEffect(() => {
        if (accessionId !== undefined) {
            setLoading(true);
            setHiddenCompounds([]);


            debouncedBoxPlotRequest(token, experimentId, accessionId, normalized)
                .then(response => {
                    setPlotTitle(response.plotTitle);
                    setDataPoints(response.dataPoints);
                    setLoading(false);
                });
        }
    }, [
        experimentId,
        accessionId,
        normalized
    ])

    if (accessionId === undefined) {
        return <>
            <div
                style={{
                    height: '450px',
                    overflow: 'hidden',
                    position: 'relative',
                    border: '1px solid #ebedf0',
                    borderRadius: 2,
                    padding: '0em',
                    textAlign: 'center',
                    background: '#fafafa',
                    marginBottom: '1em',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    width: '100%',
                }}
            >
                <div style={{
                    height: '100%',
                    alignContent: 'center',
                    minWidth: '700px',
                }}>
                    <div id={'peptideBoxPlot'}>
                        <Text type={'secondary'} strong>
                            <BoxPlotTwoTone style={{fontSize: '5em'}}/>
                        </Text>

                        <Title type={'secondary'} level={4} underline>
                            Hover over a point in scatter plot above to load related peptide box plot.
                        </Title>
                    </div>
                </div>
            </div>
        </>;
    } else if (loading) {
        return <>
            <div
                style={{
                    height: '450px',
                    overflow: 'hidden',
                    position: 'relative',
                    border: '1px solid #ebedf0',
                    borderRadius: 2,
                    padding: '0em',
                    textAlign: 'center',
                    background: '#fafafa',
                    marginBottom: '1em',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    width: '100%',
                }}
            >
                <div style={{
                    height: '100%',
                    alignContent: 'center',
                    minWidth: '700px',
                }}>
                    <div>
                        <Text type={'secondary'} strong>
                            <BoxPlotTwoTone style={{fontSize: '5em'}}/>

                            <br/>

                            Generating box plot...
                        </Text>

                        <Spin style={{marginTop: '1em'}}/>
                    </div>
                </div>
            </div>
        </>;
    } else {
        return <>
            <div
                style={{
                    height: '450px',
                    overflow: 'hidden',
                    position: 'relative',
                    border: '1px solid #ebedf0',
                    borderRadius: 2,
                    padding: '0em',
                    textAlign: 'center',
                    background: '#fafafa',
                    marginBottom: '1em',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    width: '100%',
                }}
            >
                <div style={{
                    height: '100%',
                    alignContent: 'center',
                    minWidth: '700px',
                }}>
                    <Plot
                        config={{
                            displaylogo: false,
                            responsive: true,
                            toImageButtonOptions: {
                                format: 'svg',
                                filename: plotTitle,
                            }
                        }}
                        layout={{
                            hovermode: 'closest',
                            title: plotTitle,
                            autosize: true,
                            showlegend: true,
                        }}
                        style={{width: '100%'}}
                        data={dataPoints}
                    />
                </div>
            </div>
        </>;
    }
}

const mapStateToProps = ({peptideBoxPlot, token}) => {
    return {
        accessionId: peptideBoxPlot.accessionId,
        token: token.token,
    }
}

export default connect(mapStateToProps, {
    setHiddenCompounds
})(PeptideBoxPlot);